<template>
  <div class="form my-4 voucher-blok">
    <div class="form-input-field code-area" v-if="(basket_voucher.price_with_discount==null)">
      <input
        ref="code"
        v-model="voucher_code"
        type="text"
        class="form-control"
        placeholder="Enter your voucher code..."
      >
    </div>
    <div class="action-area">
      <button
        :disabled="items.length < min_count"
        type="button"
        @click="processVoucher(voucher_code)"
        class="btn cta-button btn-primary btn-secondary btn-block"
      >{{ !(basket_voucher.price_with_discount==null) ? `Remove Code '${voucher}'` : 'Apply Voucher' }}</button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  props: ["placeHolder", "buttonLabel", "mod"],
  computed: {
    ...mapState({
      voucher: state => state.voucher.code,
      meal_preferences: state => state.profile.meal_preferences,
      items: state => state.basket.items,
      min_count: state => state.basket.config.min_count,
      applied_voucher: state => state.basket.voucher.code,
      basket_voucher: state => state.basket.voucher,
      basket_config: state => state.basket.config
    }),
    voucher_code: {
      get: function() {
        return this.voucher;
      },
      set: function(v) {
        this.prepareVoucher(v);
      }
    },
  },
  methods: {
    ...mapActions("voucher", ["checkVoucher", "applyVoucher", "prepareVoucher"]),
    ...mapActions("basket", [, "unApplyVoucher", "setVoucher"]),
    processVoucher(code, force = false) {
      const recipe_ids = this.items.map(v => (v.recipe ? v.recipe.id : ""));
      if (!this.basket_voucher.price_with_discount || force) {
        this.$refs.code.classList.remove("error");
        this.checkVoucher(code)
          .then(async v => {
            const voucher_data = await this.applyVoucher({
              code: code,
              portion_count: this.meal_preferences.people,
              delivery_weekday: this.meal_preferences.shipping_date.day,
              shipping_run: this.meal_preferences.shipping_date.id,
              recipe_ids: recipe_ids.join(",")
            });
            voucher_data.code = code;
            this.setVoucher(voucher_data);
          })
          .catch(e => {
            this.$refs.code.classList.add("error");
          });
      } else {
        this.unApplyVoucher();
      }
    }
  }
};
</script>